import http from '../../axios'
import store from '../../store'

export default {
  state: {
    callDistribution: undefined,
    answeredCalls: undefined,
    voiceMails: undefined,
    averageDuration: undefined,
    usage: undefined,
    balance: undefined,
    overdueInvoices: undefined,
    integrationError: false
  },
  getters: {
    callDistribution(state) {
      return state.callDistribution
    },
    answeredCalls(state) {
      return state.answeredCalls
    },
    voiceMails(state) {
      return state.voiceMails
    },
    averageDuration(state) {
      return state.averageDuration
    },
    usage(state) {
      return state.usage
    },
    balance(state) {
      return state.balance
    },
    overdueInvoices(state) {
      return state.overdueInvoices
    },
    integrationError(state) {
      return state.integrationError
    }
  },
  mutations: {
    setCallDistribution(state, payload) {
      state.callDistribution = payload
    },
    setAnsweredCalls(state, payload) {
      state.answeredCalls = payload
    },
    setVoiceMails(state, payload) {
      state.voiceMails = payload
    },
    setAverageDuration(state, payload) {
      state.averageDuration = payload
    },
    setUsage(state, payload) {
      state.usage = payload
    },
    setBalance(state, payload) {
      state.balance = payload
    },
    setOverdueInvoices(state, payload) {
      state.overdueInvoices = payload
    },
    setIntegrationError(state, payload) {
      state.integrationError = payload
    }
  },
  actions: {
    async fetchCallDistribution({ commit }) {
      commit('setError', null)
      try {
        const response = await http.get(
          `sip/provisioningwa/api/v2/tenant/statistics/calls-distribution?tenant_id=${store.getters.currentAccount.id}`
        )
        if (response.data.success) {
          commit('setCallDistribution', response.data.data.callDistribution)
          return {
            success: true,
            data: { ...response.data.data.callDistribution }
          }
        } else {
          commit('setError', response.data.error.message)
        }
      } catch (error) {
        if (error.response) {
          commit('setError', error.response.data.error.message)
          return {
            success: false,
            errors: { ...error.response.data.error.errors }
          }
        } else {
          commit('setError', error.message)
          return {
            success: false,
            errors: {}
          }
        }
      }
    },
    async fetchAnsweredCalls({ commit }) {
      commit('setError', null)
      try {
        const response = await http.get(
          `sip/provisioningwa/api/v2/tenant/statistics/tenant-calls?tenant_id=${store.getters.currentAccount.id}`
        )
        if (response.data.success) {
          commit('setAnsweredCalls', response.data.data.totalCalls)
          return {
            success: true,
            data: { ...response.data.data.totalCalls }
          }
        } else {
          commit('setError', response.data.error.message)
        }
      } catch (error) {
        if (error.response) {
          commit('setError', error.response.data.error.message)
          return {
            success: false,
            errors: { ...error.response.data.error.errors }
          }
        } else {
          commit('setError', error.message)
          return {
            success: false,
            errors: {}
          }
        }
      }
    },
    async fetchVoiceMails({ commit }) {
      commit('setError', null)
      try {
        const response = await http.get(
          `sip/provisioningwa/api/v2/tenant/statistics/tenant-voice-mails?tenant_id=${store.getters.currentAccount.id}`
        )
        if (response.data.success) {
          commit('setVoiceMails', response.data.data.voiceMail)
          return {
            success: true,
            data: { ...response.data.data.voiceMail }
          }
        } else {
          commit('setError', response.data.error.message)
        }
      } catch (error) {
        if (error.response) {
          commit('setError', error.response.data.error.message)
          return {
            success: false,
            errors: { ...error.response.data.error.errors }
          }
        } else {
          commit('setError', error.message)
          return {
            success: false,
            errors: {}
          }
        }
      }
    },
    async fetchAverageDuration({ commit }) {
      commit('setError', null)
      try {
        const response = await http.get(
          `sip/provisioningwa/api/v2/tenant/statistics/calls-average-duration?tenant_id=${store.getters.currentAccount.id}`
        )
        if (response.data.success) {
          commit('setAverageDuration', response.data.data.averageDuration)
          return {
            success: true,
            data: { ...response.data.data.averageDuration }
          }
        } else {
          commit('setError', response.data.error.message)
        }
      } catch (error) {
        if (error.response) {
          commit('setError', error.response.data.error.message)
          return {
            success: false,
            errors: { ...error.response.data.error.errors }
          }
        } else {
          commit('setError', error.message)
          return {
            success: false,
            errors: {}
          }
        }
      }
    },
    async fetchUsage({ commit }) {
      commit('setError', null)
      try {
        const response = await http.get(
          `/billing/api/v1/usage?tenant_uuid=${
            store.getters.currentAccount.id
          }&today=${new Date().toJSON().slice(0, 10)}`
        )
        if (response.data.success) {
          commit('setUsage', response.data.data.usage)
          return {
            success: true,
            data: { ...response.data.data }
          }
        } else {
          // commit('setError', response.data.error.message)
          commit('setUsage', { error: true })
        }
      } catch (error) {
        if (error.response) {
          commit('setError', error.response.data.error.message)
          return {
            success: false,
            errors: { ...error.response.data.error.errors }
          }
        } else {
          commit('setError', error.message)
          commit('setUsage', { error: true })
        }
      }
    },
    async fetchBalance({ commit }) {
      commit('setError', null)
      try {
        const response = await http.get(
          `/billing/api/v1/dashboard?tenant_uuid=${store.getters.currentAccount.id}`
        )
        if (response.data.success) {
          commit('setBalance', {
            amount: response.data.data.dashboard.balance,
            currency: response.data.data.dashboard.currency
          })
          return {
            success: true,
            data: { ...response.data.data }
          }
        } else {
          // commit('setError', response.data.error.message)
          commit('setBalance', { error: true })
        }
      } catch (error) {
        if (error.response) {
          commit('setError', error.response.data.error.message)
          return {
            success: false,
            errors: { ...error.response.data.error.errors }
          }
        } else {
          commit('setError', error.message)
          commit('setBalance', { error: true })
        }
      }
    },
    async fetchOverdueInvoices({ commit }) {
      commit('setError', null)
      try {
        const response = await http.get(
          `packages/api/v1/dashboard/invoices/overdue?online=1&tenant_id=${store.getters.currentAccount.id}`
        )
        if (response.data.success) {
          commit('setOverdueInvoices', response.data.data.totalOverdueInvoices)
          return {
            success: true,
            data: { ...response.data.data.totalOverdueInvoices }
          }
        } else {
          commit('setError', response.data.error.message)
        }
      } catch (error) {
        commit('setOverdueInvoices', { error: true })
        if (error.response) {
          // commit('setError', error.response.data.error.message)
          return {
            success: false,
            errors: { ...error.response.data.error.errors }
          }
        } else {
          commit('setError', error.message)
          return {
            success: false,
            errors: {}
          }
        }
      }
    }
  }
}
